import React, { useState } from "react";
import SEO from "../Components/SEO";

function Contact() {

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const res = await fetch("http://localhost:5000/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    ime: form.name,
                    email: form.email,
                    telefon: form.phone,
                    body: form.message
                })
            });

            const data = await res.json();

            if (data.success) {
                setMessage("Poruka je poslata!");

                setForm({
                    name: "",
                    email: "",
                    phone: "",
                    message: ""
                });

            } else {
                setMessage("Greška pri slanju poruke.");
            }

        } catch (err) {
            console.error(err);
            setMessage("Server greška.");
        }

    };

    return (
        <>
            <SEO
                title="Kontakt | JODUST ALU i PVC stolarija"
                description="Kontaktirajte JODUST za besplatnu procenu i ponudu za ALU i PVC stolariju. Nalazimo se u Lebanu, Srbija. Pozovite nas ili pošaljite upit."
                keywords="kontakt JODUST, stolarija Lebane telefon, stolarija Leskovac, ponuda za prozore, naručivanje stolarije"
            />

            <main>

                {/* HERO */}
                <section
                    className="text-white text-center py-5"
                    style={{ backgroundColor: "#1f4068" }}
                >
                    <div className="container py-5">
                        <h1 className="display-5 fw-bold">Kontaktirajte nas</h1>
                        <p className="lead mt-3">
                            Za sva pitanja u vezi PVC i ALU stolarije slobodno nas kontaktirajte.
                        </p>
                    </div>
                </section>

                {/* CONTACT SECTION */}
                <section className="py-5 bg-light">
                    <div className="container">

                        <div className="row">

                            {/* INFO */}
                            <div className="col-md-5 mb-4">

                                <h3 className="fw-bold mb-4">Kontakt informacije</h3>

                                <p>
                                    <strong>Firma:</strong><br />
                                    JODUST 016
                                </p>

                                <p>
                                    <strong>Adresa:</strong><br />
                                    Lebane, Srbija
                                </p>

                                <p>
                                    <strong>Telefon:</strong><br />
                                    +381 XX XXX XXXX
                                </p>

                                <p>
                                    <strong>Email:</strong><br />
                                    info@jodust.rs
                                </p>

                                <p>
                                    <strong>Radno vreme:</strong><br />
                                    Ponedeljak – Subota<br />
                                    08:00 – 17:00
                                </p>

                            </div>

                            {/* FORM */}
                            <div className="col-md-7">

                                <h3 className="fw-bold mb-4">Pošaljite nam poruku</h3>

                                <form onSubmit={handleSubmit}>

                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Vaše ime"
                                            name="name"
                                            value={form.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Email adresa"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Telefon"
                                            name="phone"
                                            value={form.phone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <textarea
                                            className="form-control"
                                            rows="5"
                                            placeholder="Vaša poruka..."
                                            name="message"
                                            value={form.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>

                                    <button className="btn btn-primary btn-lg">
                                        Pošalji poruku
                                    </button>
                                    {message && (
                                        <div className="mt-3 text-center" style={{ color: "red", fontWeight: "bold" }}>
                                            {message}
                                        </div>
                                    )}
                                </form>

                            </div>

                        </div>

                    </div>
                </section>

                {/* MAP */}
                <section>

                    <iframe
                        title="map"
                        src="https://maps.google.com/maps?q=42.925222,21.738917&z=15&output=embed"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        loading="lazy"
                    ></iframe>

                </section>

            </main>
        </>
    );
}

export default Contact;